import NumericKeyboard from './NumericKeyboard';

export default NumericKeyboard;
